export const csvHeadersData = [
  { label: "Account Name", key: "accountName" },
  { label: "Worksite Name", key: "siteName" },
  { label: "Asset Name", key: "assetName" },
  { label: "User Name", key: "userName" },
  { label: "User Type", key: "userType" },
  { label: "Date/Time", key: "dateTimeFormatted" },
  { label: "Event Category", key: "eventCategory" },
  { label: "Event", key: "systemEvent" },

  { label: "Unlock Method", key: "unlockMethod" },
  { label: "Connection Type", key: "connectionType" },
  { label: "Lock Reason", key: "lockReason" },
  { label: "Config Update Type", key: "configUpdateType" },
  { label: "Email", key: "email" },
  { label: "Platform", key: "platform" },
  { label: "Result", key: "result" },
];

export const categoryValueToLabelMap = {
  admin_menu_access: "Admin Menu Access",
  config_update: "Config Update",
  device_shutdown: "Device Shutdown",
  web_auth: "Web Auth",
  internet_activity: "Internet Activity",
  lock_unlock: "Lock/Unlock",
};

export const eventValueToLabelMapping = {
  admin_menu_login: "Admin Menu Login",
  config_update: "Config Update",
  web_login: "Login",
  i_connected: "Connected",
  i_disconnected: "Disconnected",
  lock: "Lock",
  unlock: "Unlock",
  device_shutdown: "Device Shutdown",
  restart: "Restart",
  shutdown: "Shutdown",
};
